import ApiService from '@/core/services/api.service';

const resource = 'v1/stores';

export default {
  /**
   * Fetch stores available to the current user
   * @returns {Promise} - Promise with the store data
   */
  getListByUser() {
    return ApiService.get(`${resource}/get-by-user`)
      .then((response) => response.data.data.stores)
      .catch((error) => {
        console.error('Error fetching stores:', error);
        throw error;
      });
  },

  /**
   * Get stores by user
   * @returns {Promise<Object>} API response with user's stores
   */
  async getByUser() {
    try {
      const response = await ApiService.get('v1/stores/get-by-user');
      return response.data.data;
    } catch (error) {
      console.error('Error fetching stores by user:', error);
      throw error;
    }
  },

  /**
   * Get all stores with pagination
   * @param {Object} params - Query parameters
   * @param {number} params.page - Page number for pagination
   * @param {number} params.pageSize - Number of items per page
   * @param {string} params.name - Store name filter
   * @returns {Promise<Object>} API response with store data
   */
  async getAll(params = {}) {
    try {
      const { page = 1, pageSize = 10, name = '' } = params;
      const response = await ApiService.query('v1/stores', {
        params: { page, pageSize, name },
      });
      return response.data.data;
    } catch (error) {
      console.error('Error fetching stores:', error);
      throw error;
    }
  },

  /**
   * Get store by ID
   * @param {number} id - Store ID
   * @returns {Promise<Object>} Store data
   */
  async getById(id) {
    try {
      const response = await ApiService.get(`v1/stores/${id}`);
      return response.data.data;
    } catch (error) {
      console.error('Error fetching store by ID:', error);
      throw error;
    }
  },

  /**
   * Search stores for autocomplete
   * @param {string} searchText - Search text
   * @param {number} limit - Maximum number of results
   * @returns {Promise<Array>} Filtered store options
   */
  async search(searchText = '', limit = 10) {
    try {
      const storeData = await this.getByUser();
      const stores = storeData.stores || [];
      
      if (!searchText.trim()) {
        return stores.slice(0, limit);
      }

      const filtered = stores.filter((store) => {
        return (
          store.name.toLowerCase().indexOf(searchText.toLowerCase()) > -1 ||
          (store.shortName && store.shortName.toLowerCase().indexOf(searchText.toLowerCase()) > -1)
        );
      });

      return filtered.slice(0, limit);
    } catch (error) {
      console.error('Error searching stores:', error);
      throw error;
    }
  },

  /**
   * Format stores for autocomplete dropdown
   * @returns {Promise<Array>} Formatted store options
   */
  async getForAutocomplete() {
    try {
      const storeData = await this.getByUser();
      const stores = storeData.stores || [];
      
      const options = [
        {
          id: null,
          name: 'Tất cả cửa hàng',
          shortName: 'Tat ca cua hang',
        },
        ...stores,
      ];

      return options;
    } catch (error) {
      console.error('Error getting stores for autocomplete:', error);
      throw error;
    }
  },
};
